<template>

    <!-- Listagem de provas concluídas -->
    <template v-if="(typeof $route.params.id === 'undefined')">
        <v-container fluid>

            <!-- Gráfico de evolução (aparece quando há ≥ 2 provas concluídas) -->
            <v-row v-if="chartDataLine" class="mb-4">
                <v-col>
                    <v-card elevation="2">
                        <v-toolbar color="primary" elevation="1">
                            <v-spacer />Minha Evolução nas Atividades<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 260px;">
                            <Line :data="chartDataLine" :options="charOptionsLine" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="chartDataAllStacked" class="mb-4">
                <v-col>
                    <v-card elevation="2">
                        <v-toolbar color="primary" elevation="1">
                            <v-spacer />Meus TBLs - AI + AE<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 320px;">
                            <Bar :data="chartDataAllStacked" :options="charOptionsStacked" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="chartDataAllGauges.length" class="mb-4">
                <v-col
                    v-for="gauge in chartDataAllGauges"
                    :key="gauge.id"
                    cols="12"
                    md="6"
                    xl="4"
                >
                    <v-card elevation="2" height="100%">
                        <v-toolbar color="primary-darken-1" elevation="1">
                            <v-spacer />{{ gauge.nome }}<v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <div class="gauge-wrap">
                                <Doughnut :data="gauge.chartData" :options="charOptionsGauge" />
                            </div>
                            <div class="gauge-caption">
                                <strong>{{ formatGrade(gauge.totalF) }}</strong>
                                <span>de {{ formatGrade(gauge.notaMaxima) }} pontos</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-data-table v-model:sort-by="sortByData" class="table elevation-2" hover
                items-per-page-text="Itens por pagina" page-text="{0}-{1} de {2}"
                :headers="headersTests" :items="listTests" :loading="loadingTests"
                @click:row="rowClick">
                <template v-slot:no-data>
                    <v-alert class="my-4" :value="true">
                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                    </v-alert>
                </template>
                <template v-slot:item.datetime="{ item }">{{ formatDate(item.columns.datetime) }}</template>
            </v-data-table>

        </v-container>
    </template>

    <!-- Detalhe da prova selecionada -->
    <template v-else-if="(typeof $route.params.id !== 'undefined')">
        <v-container fluid>

            <!-- Cabeçalho -->
            <v-row>
                <v-col>
                    <v-card class="mx-auto" prepend-icon="mdi-note">
                        <template v-slot:title>{{ provaNome }}</template>
                        <v-card-text>
                            <p><strong>Data:</strong> {{ datetime }}</p>
                            <p><strong>Status:</strong> {{ statusProva }}</p>
                            <p><strong>{{ pt }}</strong> {{ provaProf }}</p>
                            <p v-if="optGabarito"><strong>Obs.:</strong> {{ optGabarito }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Notas resumo -->
            <v-row>
                <v-col>
                    <v-card class="mx-auto" min-height="100">
                        <v-container class="text-center">
                            <v-row justify="center">
                                <v-col cols="12" md="3" sm="4">
                                    Nota Maxima:
                                    <v-btn active block class="disable-events" rounded="xl" size="x-large">{{ notaMaxima }}</v-btn>
                                </v-col>
                                <v-col cols="12" md="3" sm="4">
                                    Nota Individual:
                                    <v-btn block class="disable-events" rounded="xl" size="x-large">{{ notaIndividual }}</v-btn>
                                </v-col>
                                <v-col cols="12" md="3" sm="4">
                                    Nota em Equipe:
                                    <v-btn block class="disable-events" rounded="xl" size="x-large">{{ notaEquipe }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Gráficos: 3 gauges (Total, AI, AE) -->
            <v-row v-if="chartDataGauge" class="mt-2">

                <v-col cols="12" md="4" sm="6">
                    <v-card elevation="2">
                        <v-toolbar color="primary" elevation="1">
                            <v-spacer />Nota Final<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 220px; position: relative;">
                            <Doughnut :data="chartDataGauge" :options="charOptionsGauge" />
                            <div style="position: absolute; bottom: 42px; left: 0; right: 0; text-align: center; font-size: 1.5rem; font-weight: bold;">
                                {{ listStudentGrades[0]?.totalF }}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4" sm="6">
                    <v-card elevation="2">
                        <v-toolbar color="secondary" elevation="1">
                            <v-spacer />Atividade Individual (AI)<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 220px; position: relative;">
                            <Doughnut :data="chartDataGaugeAI" :options="charOptionsGauge" />
                            <div style="position: absolute; bottom: 42px; left: 0; right: 0; text-align: center; font-size: 1.5rem; font-weight: bold;">
                                {{ listStudentGrades[0]?.totalPI }}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4" sm="6">
                    <v-card elevation="2">
                        <v-toolbar elevation="1" style="background: #B88645; color: #fff;">
                            <v-spacer />Atividade em Equipe (AE)<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 220px; position: relative;">
                            <Doughnut :data="chartDataGaugeAE" :options="charOptionsGauge" />
                            <div style="position: absolute; bottom: 42px; left: 0; right: 0; text-align: center; font-size: 1.5rem; font-weight: bold;">
                                {{ listStudentGrades[0]?.totalPG }}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>

            <!-- Gráficos: barras por questão — AI e AE separados -->
            <v-row v-if="chartDataBarAI" class="mt-2">

                <v-col cols="12" md="6">
                    <v-card elevation="2">
                        <v-toolbar color="secondary" elevation="1">
                            <v-spacer />Nota por Questão — AI<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 260px;">
                            <Bar :data="chartDataBarAI" :options="charOptionsBarPerQ" />
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="6">
                    <v-card elevation="2">
                        <v-toolbar elevation="1" style="background: #B88645; color: #fff;">
                            <v-spacer />Nota por Questão — AE<v-spacer />
                        </v-toolbar>
                        <v-card-text style="height: 260px;">
                            <Bar :data="chartDataBarAE" :options="charOptionsBarPerQ" />
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>

            <!-- Tabela de notas detalhada -->
            <v-row>
                <v-col>
                    <v-card class="mx-auto" min-height="100">
                        <v-card-text ref="elementToConvert">
                            <v-data-table-virtual v-model:sort-by="sortByName" class="table elevation-2"
                                :headers="headersStudentsGrades"
                                :items="listStudentGrades" :loading="loadingStudentsGrades">
                                <template v-slot:no-data>
                                    <v-alert class="my-4" :value="true">
                                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                                    </v-alert>
                                </template>
                            </v-data-table-virtual>
                        </v-card-text>
                        <v-card-actions class="ml-2">
                            <v-row>
                                <v-col cols="12" md="2" sm="3"><p><strong>AI:</strong> Atividade Individual</p></v-col>
                                <v-col cols="12" md="2" sm="3"><p><strong>AE:</strong> Atividade em Equipe</p></v-col>
                                <v-col cols="12" md="2" sm="3"><p><strong>Q:</strong> Questao</p></v-col>
                                <v-spacer />
                                <v-col class="mt-n3" cols="12" md="3" sm="3">
                                    <div style="align-items: center; display: flex;">
                                        <p>Exportar dados para:</p>
                                        <download-excel :data="listStudentGrades" :fields="json_fields" :name="provaNome + '.xls'">
                                            <v-btn color="secondary" icon="mdi-microsoft-excel" variant="text" />
                                        </download-excel>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </template>

    <v-snackbar v-model="snackbar" :color="sbColor">
        {{ sbMessage }}
        <template v-slot:actions>
            <v-btn @click="snackbar = false">Fechar</v-btn>
        </template>
    </v-snackbar>

</template>

<style type="text/css">
.disable-events {
    pointer-events: none;
}

.v-data-table.table .v-table__wrapper>table>thead>tr th,
.v-data-table.table .v-table__wrapper>table tbody>tr th {
  background-color: #00264f;
  color: white;
}

.text-danger {
  color: rgb(176, 0, 32);
  font-size: 12px;
  margin-top: 4px;
  margin-left: 4px;
}
.gauge-wrap {
  height: 170px;
  position: relative;
}

.gauge-caption {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-top: -54px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.gauge-caption strong {
  color: #16324a;
  font-size: 24px;
}

.gauge-caption span {
  color: #5f6b7a;
  font-size: 13px;
}
</style>

<script src="@/assets/js/alunoNota.js" />
